import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./CreateLeadAutomationForm.module.css";

import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import {
  checkObjectsEqual,
  getCombinedAssignees,
} from "../../../../../../components/CommonFunctions/CommonFunctions";
import CancelPopup from "../../../../../../components/CommonPopups/CancelPopup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomizedDropdownForAutomation from "./CustomizedDropdown/CustomizedDropdownForAutomation";
import SelectedFieldCard from "./CustomizedDropdown/SelectedCard";
import Connector from "./CustomizedDropdown/Connector";
import CustomizedDropdownForAutomationForAssignee from "./CustomizedDropdown/MultileSelectionAssignee";
import FinalCustomizedDropdown from "./CustomizedDropdown/FinalCustomized";
import { useSelector } from "react-redux";
import { getStreams } from "../../../../Integrations/service/IntegrationsSlice";
import { getSubDomainAccessStatus } from "../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { GetAllWebforms } from "../../../../Inbound/Webform/service/webform.request";
import { resetSaveUpdateSuccess } from "../../../service/LeadAutomationSlice";
import BatchSkeleton from "../../../../../../components/Skeletons/BatchSkeleton";
import FinalConfirmPopup from "./FinalConfirmPopup";
import { getAllCourseByInstituteRequest } from "../../../../Manage/ManageCourse/service/courseSlice";
import { getBranchList } from "../../../../Manage/ManageBranch/service/Branchslice";
import EdufinSkeleton from "../../../../../../components/Skeletons/EdufinSkeleton";
import InstituteSkeleton from "../../../../../../components/Skeletons/InstituteSkeleton";
import SplitSkeleton from "../../../../../../components/Skeletons/SplitSkeleton";
import UserProfileBoxSkeleton from "../../../../../../components/Skeletons/UserProfileBoxSkeleton";
import StaffSkeleton from "../../../../../../components/Skeletons/StaffSkeleton";
import AutomationSkeleton from "../../../../../../components/Skeletons/AutomationSkeleton";
import { setToastNotification } from "../../../../../../components/ToastNotification/service/toastNotificationSlice";
import { GetAllCourseByInstituteRequest } from "../../../../Manage/ManageCourse/service/course.request";

function CreateLeadAutomationForm(props: any) {
  const {
    add,
    SaveLeadAutomationConfig,
    UpdateLeadAutomationConfig,
    editLeadAutomationConfigSuccess,
    editLeadAutomationConfigLoading,
    saveLeadAutomationConfigLoading,
    saveLeadAutomationConfigSuccess,
    GetLeadAutomation,
    getSavedLeadAutomationData,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const employees = useSelector((state: any) => state.staff.staffList);
  const batchList = useSelector((state: any) => state.batch.batchList);
  const courseList = useSelector((state: any) => state.courses.courses);
  const { userById } = useSelector((state: any) => state.userDetails);
  const branchList = useSelector((state: any) => state.branch.branchList);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const { metaStreams } = useSelector((state: any) => state.appIntegrations);
  const [streams, setStreams] = useState<any>(null);
  const [webforms, setWebforms] = useState<any>(null);
  const [loader, setLoader] = useState(false);
  const [course, setCourse] = useState<any>(null);

  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const [draggedField, setDraggedField] = useState<any>(null);
  const [additionalFields, setAdditionalFields] = useState<any[]>([]);

  const [cancelModal, setCancelModal] = React.useState<boolean>(false);

  const [formName, setFormName] = useState<string>("");

  const containerRef = useRef<any>(null);

  const [draggedFieldIndex, setDraggedFieldIndex] = useState<number | null>(
    null
  );
  const [dragActive, setDragActive] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const leadAutomationId = searchParams.get("leadAutomationId");
  const [isDropdownFieldFocused, setIsDropdownFieldFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleChangeName = (e: any) => {
    setFormName(e.target.value);
  };

  function handleOnDrag(e: any, field: any) {
    setDraggedField(field);
  }
  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );

  const filteredBatches =
    batchList &&
    batchList?.filter(
      (d: any) =>
        (d?.batchStatus === "ONGOING" || d?.batchStatus === "UPCOMING") &&
        d?.status === "ACTIVE" &&
        d?.batchConductType === "REGULAR_BATCH"
    );

  useEffect(() => {
    GetLeadAutomation(instituteFromLocalStorage?.id);
    // dispatch<any>(
    //   getAllCourseByInstituteRequest({
    //     id: activeInstitute?.id,
    //   })
    // );
    GetAllCourseByInstituteRequest({ id: activeInstitute?.id })
      .then((res: any) => {
        setCourse(res?.data?.data);
      })
      .catch((err: any) => {});
    dispatch<any>(getBranchList(activeInstitute?.id));
  }, []);

  useEffect(() => {
    if (leadAutomationId && getSavedLeadAutomationData) {
      setLoader(true);

      const data = getSavedLeadAutomationData?.find(
        (d: any) => d?.id === leadAutomationId
      );

      // -----------------------------
      // Update FIELDS (right side UI)
      // -----------------------------
      let savedSourceOptions: any[] = [];

      if (data?.trigger === "META") {
        savedSourceOptions =
          streams?.map((s: any) => ({
            name: s.name,
            id: s.id,
          })) ?? [];
      }

      if (data?.trigger === "WEBFORM") {
        savedSourceOptions =
          webforms?.map((w: any) => ({
            name: w?.name,
            id: w?.id,
            type: w?.type,
            branchId: w?.branchId,
          })) ?? [];
      }

      if (data?.trigger === "EXCEL") {
        savedSourceOptions = [{ name: "Excel", id: "EXCEL" }];
      }

      setFields((prev) =>
        prev.map((f) => {
          let selectedOption: any = "";

          switch (f.fieldName) {
            case "Trigger":
              selectedOption = data?.trigger || "";
              break;
            // case "Trigger":
            //   // Normalize saved trigger → UI trigger
            //   selectedOption =
            //     data?.trigger === "WEBFORM"
            //       ? "Webform"
            //       : data?.trigger === "META"
            //       ? "Meta"
            //       : data?.trigger === "EXCEL"
            //       ? "Excel"
            //       : "";
            //   break;

            case "Source":
              selectedOption = data?.source
                ? {
                    sourceId: data?.source?.sourceId,
                    sourceName: data?.source?.sourceName,
                    type: data?.source?.type,
                    branchId: data?.source?.branchId,
                  }
                : "";
              break;
            case "Source":
              selectedOption = data?.source
                ? {
                    sourceId: data?.source?.sourceId,
                    sourceName: data?.source?.sourceName,
                  }
                : "";
              break;
            // return {
            //   ...f,
            //   selectedOption,
            //   options: savedSourceOptions, // ★ Now works
            // };
            case "Course":
              selectedOption = data?.course
                ? {
                    courseId: data?.course?.courseId,
                    courseName: data?.course?.courseName,
                  }
                : "";
              break;

            case "Branch":
              selectedOption = data?.branch
                ? {
                    branchId: data?.branch?.branchId,
                    branchName: data?.branch?.branchName,
                  }
                : "";
              break;

            case "Batch":
              selectedOption = data?.batch
                ? {
                    batchId: data?.batch?.batchId,
                    batchName: data?.batch?.batchName,
                  }
                : "";
              break;

            case "Assignee Method":
              selectedOption =
                data?.assignmentMethod === "ROUND_ROBIN_ASSIGNMENT"
                  ? "Multiple Assignee"
                  : "Single Assignee";
              break;

            case "Assignee":
              if (data?.assignmentMethod === "ROUND_ROBIN_ASSIGNMENT") {
                selectedOption = data?.assignees?.map((a: any) => ({
                  id: a?.assigneeId,
                  name: a?.assigneeName,
                }));
              } else {
                const a = data?.assignees?.[0];
                selectedOption = a
                  ? { id: a?.assigneeId, name: a?.assigneeName }
                  : "";
              }
              break;

            default:
              break;
          }
          if (
            (data?.trigger === "WEBFORM" ||
              data?.trigger === "META" ||
              data?.trigger === "EXCEL") &&
            f?.fieldName === "Source"
          ) {
            return { ...f, selectedOption, options: savedSourceOptions };
          } else {
            return { ...f, selectedOption };
          }
          // if (f.fieldName === "Source") {
          //   return { ...f, selectedOption, options: savedSourceOptions };
          // }

          // return { ...f, selectedOption };
        })
      );

      // -----------------------------
      // Update additionalFields (left side box)
      // -----------------------------
      const extraFields = [
        {
          fieldName: "Trigger",
          selectedOption: data?.trigger,
        },
        {
          fieldName: "Source",
          selectedOption: data?.source
            ? {
                sourceId: data?.source?.sourceId,
                sourceName: data?.source?.sourceName,
              }
            : "",
        },
        {
          fieldName: "Course",
          selectedOption: data?.course
            ? {
                courseId: data?.course?.courseId,
                courseName: data?.course?.courseName,
              }
            : "",
        },
        {
          fieldName: "Branch",
          selectedOption: data?.branch
            ? {
                branchId: data?.branch?.branchId,
                branchName: data?.branch?.branchName,
              }
            : "",
        },
        {
          fieldName: "Batch",
          selectedOption: data?.batch
            ? {
                batchId: data?.batch?.batchId,
                batchName: data?.batch?.batchName,
              }
            : "",
        },
        {
          fieldName: "Assignee Method",
          selectedOption:
            data?.assignmentMethod === "ROUND_ROBIN_ASSIGNMENT"
              ? "Multiple Assignee"
              : "Single Assignee",
        },
        {
          fieldName: "Assignee",
          selectedOption:
            data?.assignmentMethod === "ROUND_ROBIN_ASSIGNMENT"
              ? data?.assignees.map((a: any) => ({
                  id: a?.assigneeId,
                  name: a?.assigneeName,
                }))
              : data?.assignees?.[0]
              ? {
                  id: data?.assignees?.[0]?.assigneeId,
                  name: data?.assignees?.[0]?.assigneeName,
                }
              : "",
        },
      ].map((item, idx) => ({ ...item, index: idx + 1 }));

      setAdditionalFields(extraFields);
      setLoader(false);
    }
  }, [leadAutomationId, getSavedLeadAutomationData, streams, webforms]);

  function handleOnDrop(e: any) {
    e.preventDefault();
    if (draggedField) {
      let fieldExist: any;

      fieldExist = additionalFields?.filter(
        (item: any) => item?.fieldName === draggedField?.fieldName
      );
      if (fieldExist?.length > 0) {
        setDraggedField(null);
      } else {
        const lastIndex =
          additionalFields?.length > 0
            ? additionalFields[additionalFields.length - 1].index || 0
            : -1;

        const updatedDraggedField = {
          ...draggedField,
          index: additionalFields?.length === 0 ? 1 : lastIndex + 1,
        };
        setAdditionalFields([...additionalFields, updatedDraggedField]);
        setDraggedField(null);
      }
    }
  }

  function handleOnDragFields(e: any, field: any, index: number) {
    setDraggedField(field);
    setDraggedFieldIndex(index);
    setDragActive(true);
  }

  function handleOnDragEnter(e: any, field: any, index: number) {
    if (draggedField !== null && draggedFieldIndex !== null) {
      const updatedFields = [...additionalFields];
      updatedFields.splice(draggedFieldIndex, 1);
      updatedFields.splice(index, 0, draggedField);
      const updatedFieldsWithIndex = updatedFields?.map(
        (item, index: number) => ({
          ...item,
          index: index + 1,
        })
      );
      setAdditionalFields(updatedFieldsWithIndex);
      setDraggedField(null);
      setDraggedFieldIndex(null);
    }
  }

  function handleOnDragOver(e: any) {
    e.preventDefault();
    if (dragActive) {
      const y = e.clientY;
      const containerRect = containerRef.current.getBoundingClientRect();
      const scrollSpeed = 10;
      let scrollDirection = 0;

      if (y < containerRect.top + 100) {
        scrollDirection = -1;
      } else if (y > containerRect.bottom - 100) {
        scrollDirection = 1;
      }

      if (scrollDirection !== 0) {
        containerRef.current.scrollTop += scrollDirection * scrollSpeed;
      }
    }
  }

  // const handleDeleteField = (fieldToDelete: any) => {
  //   const updatedFields = additionalFields
  //     ?.filter((field) => field !== fieldToDelete)
  //     ?.map((item: any, index: number) => ({
  //       ...item,
  //       index: index + 1,
  //     }));

  //   setAdditionalFields(updatedFields);
  // };

  const handleDeleteField = (fieldToDelete: any) => {
    let fieldsToRemove: any = [];

    // If Batch is removed → also remove Branch & Course
    // if (fieldToDelete.fieldName === "Batch") {
    //   fieldsToRemove = ["Batch", "Branch", "Course"];
    // } else {
    fieldsToRemove = [fieldToDelete.fieldName];
    // }

    const updatedFields = additionalFields
      ?.filter((field) => !fieldsToRemove.includes(field.fieldName))
      ?.map((item: any, index: number) => ({
        ...item,
        index: index + 1,
      }));

    setAdditionalFields(updatedFields);
  };

  const closeCancelModal = () => {
    setCancelModal(false);
  };

  const cancelYesBtn = () => {
    setCancelModal(false);
    navigate(`/app/Settings/Customize`);
    localStorage.removeItem("createLeadFormName");
  };

  const mapFieldsToApiBody = (fields: any[]) => {
    const getField = (name: string) => fields.find((f) => f.fieldName === name);

    const typeOfTrigger = getField("Trigger")?.selectedOption;

    const sourceField = getField("Source")?.selectedOption;
    const courseField = getField("Course")?.selectedOption;
    const branchField = getField("Branch")?.selectedOption;
    const batchField = getField("Batch")?.selectedOption;
    const assigneeMethodField = getField("Assignee Method");
    const assigneeField = getField("Assignee");

    const assignmentMethod =
      assigneeMethodField?.selectedOption === "Multiple Assignee"
        ? "ROUND_ROBIN_ASSIGNMENT"
        : "SINGLE_ASSIGNEE";

    const source = sourceField
      ? {
          sourceId: sourceField?.sourceId || sourceField?.id,
          sourceName: sourceField?.sourceName || sourceField?.name,
          type: sourceField?.type,
          branchId: sourceField?.branchId,
        }
      : null;

    const course = courseField
      ? {
          courseId: courseField?.courseId || courseField?.id,
          courseName: courseField?.courseName || courseField?.name,
        }
      : null;

    const branch = branchField
      ? {
          branchId: branchField?.branchId || branchField?.id,
          branchName: branchField?.branchName || branchField?.name,
        }
      : null;

    const batch = batchField
      ? {
          batchId: batchField?.batchId || batchField?.id,
          batchName: batchField?.batchName || batchField?.name,
        }
      : null;

    let assignees: any[] = [];

    if (Array.isArray(assigneeField?.selectedOption)) {
      assignees = assigneeField.selectedOption.map((item: any) => ({
        assigneeId: item?.id,
        assigneeName: item?.name,
      }));
    } else {
      const item = assigneeField?.selectedOption;
      if (item) {
        assignees = [
          {
            assigneeId: item?.id,
            assigneeName: item?.name,
          },
        ];
      }
    }
    const trigger =
      typeOfTrigger === "Webform"
        ? "WEBFORM"
        : typeOfTrigger === "Meta"
        ? "META"
        : typeOfTrigger === "Excel"
        ? "EXCEL"
        : "";

    return {
      instituteId: activeInstitute?.id,
      trigger,
      source,
      course,
      branch,
      batch,

      assignmentMethod,
      assignees,

      createdByName: authUser?.firstName + " " + authUser?.lastName,
      createdById: authUser?.institute[0]?.instituteDetails?.id,

      updatedByName: authUser?.firstName + " " + authUser?.lastName,
      updatedById: authUser?.institute[0]?.instituteDetails?.id,
    };
  };

  const deepEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);

  const compareFieldSelections = (fields: any[], additionalFields: any[]) => {
    let hasMismatch = false;

    for (const f of fields) {
      const match = additionalFields.find((x) => x.fieldName === f.fieldName);
      if (!match) {
        hasMismatch = true;
        continue;
      }

      const a = f.selectedOption;
      const b = match.selectedOption;

      if (Array.isArray(a) && Array.isArray(b)) {
        if (!deepEqual(a, b)) hasMismatch = true;
        continue;
      }

      if (Array.isArray(a) || Array.isArray(b)) {
        hasMismatch = true;
        continue;
      }

      if (typeof a === "string" || typeof a === "number") {
        if (a !== b) hasMismatch = true;
        continue;
      }

      if (!deepEqual(a, b)) hasMismatch = true;
    }

    return hasMismatch;
  };

  const handleSubmit = async () => {
    try {
      const body = mapFieldsToApiBody(additionalFields);
      if (add) {
        SaveLeadAutomationConfig(body);
      } else {
        const hasMisMatch = compareFieldSelections(fields, additionalFields);
        if (hasMisMatch) {
          dispatch(
            setToastNotification({
              message: "Please Drag and Drop Newly selected Field",
              type: "error",
              snackOpen: true,
            })
          );
        } else {
          const data = getSavedLeadAutomationData?.find(
            (d: any) => d?.id === leadAutomationId
          );
          UpdateLeadAutomationConfig({
            ...body,
            id: data?.id,
            status: data?.status,
            trigger: body?.trigger === "" ? data?.trigger : body?.trigger,
          });
        }
      }
    } catch (error) {}
  };

  React.useEffect(() => {
    dispatch<any>(
      getStreams({
        id: activeInstitute?.id,
        branchId: hasAllBranchAccess ? "" : userById?.branchId,
      })
    );
    const body = {
      instituteId: activeInstitute?.id,
      limit: 1000,
      // branchId: !hasAllBranchAccess ? userById?.branchId : "ALL",
    };
    GetAllWebforms(body)?.then((res: any) => {
      const result = res?.data?.data;
      const data = result?.returnData
        ?.filter((ds: any) => ds?.isCreateLead === false)
        ?.map((d: any) => {
          return {
            name: d?.formName,
            id: d?.id,
            type: d?.type,
            branchId: d?.branchId,
          };
        });
      // const data = result?.returnData?.map((d: any) => {
      //   return { name: d?.formName, id: d?.id };
      // });
      setWebforms(data);
    });
  }, []);

  React.useEffect(() => {
    if (
      saveLeadAutomationConfigSuccess === true ||
      editLeadAutomationConfigSuccess
    ) {
      navigate(`/app/Settings/LeadAutomation`);
      dispatch(resetSaveUpdateSuccess());
    }
  }, [saveLeadAutomationConfigSuccess, editLeadAutomationConfigSuccess]);

  React.useEffect(() => {
    if (metaStreams) {
      const data = metaStreams?.map((d: any) => {
        return { name: d?.streamName, id: d?.id };
      });
      setStreams(data);
    }
  }, [metaStreams]);

  const [fields, setFields] = useState([
    {
      fieldType: "select",
      fieldName: "Trigger",
      selectedOption: "",
      options: [
        { name: "Meta", id: "META" },
        { name: "Webform", id: "WEBFORM" },
        { name: "Excel", id: "EXCEL" },
      ],
    },
    {
      fieldType: "select",
      fieldName: "Source",
      selectedOption: "",
      options: [],
    },
    {
      fieldType: "select",
      fieldName: "Course",
      selectedOption: "",
      options:
        course &&
        course?.map((c: any) => ({
          name: c.courseName,
          id: c.id,
        })),
    },
    {
      fieldType: "select",
      fieldName: "Branch",
      selectedOption: "",
      options: branchList?.map((b: any) => ({
        name: b.branchName,
        id: b.id,
      })),
    },
    {
      fieldType: "select",
      fieldName: "Batch",
      selectedOption: "",
      options:
        filteredBatches &&
        filteredBatches?.map((bt: any) => ({
          name: bt.batchName,
          id: bt.id,
        })),
    },
    {
      fieldType: "select",
      fieldName: "Assignee Method",
      selectedOption: "",
      options: [
        { name: "Single Assignee", id: "MANUAL" },
        { name: "Multiple Assignee", id: "AUTO" },
      ],
    },
    {
      fieldType: "select",
      fieldName: "Assignee",
      selectedOption: "",
      options: [], // we'll update dynamically
    },
  ]);

  useEffect(() => {
    if (!course) return;

    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Course"
          ? {
              ...f,
              options: course.map((c: any) => ({
                name: c.courseName,
                id: c.id,
              })),
            }
          : f
      )
    );
  }, [course]);

  const selectedCourseId = useMemo(() => {
    const courseField: any = fields.find((f) => f.fieldName === "Course");
    return (
      courseField?.selectedOption?.courseId ||
      courseField?.selectedOption?.id ||
      null
    );
  }, [fields]);

  const selectedBranchId = useMemo(() => {
    const branchField: any = fields?.find((f: any) => f.fieldName === "Branch");
    return branchField?.selectedOption?.branchId ?? null;
  }, [fields]);

  useEffect(() => {
    const filteredBatchess =
      batchList &&
      batchList?.filter(
        (d: any) =>
          (d?.batchStatus === "ONGOING" || d?.batchStatus === "UPCOMING") &&
          d?.status === "ACTIVE" &&
          d?.batchConductType === "REGULAR_BATCH"
      );

    if (!filteredBatchess) return;

    let filteredBatches = filteredBatchess;

    if (selectedCourseId) {
      filteredBatches = filteredBatches?.filter(
        (b: any) => b?.courseId === selectedCourseId
      );
    }

    if (selectedBranchId) {
      filteredBatches = filteredBatches.filter(
        (b: any) => b?.branchId === selectedBranchId
      );
    }

    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Batch"
          ? {
              ...f,
              options: filteredBatches.map((bt: any) => ({
                name: bt.batchName,
                id: bt.id,
              })),
              selectedOption: "", // reset if filtering changed
            }
          : f
      )
    );
  }, [selectedCourseId, selectedBranchId, batchList]);

  useEffect(() => {
    if (!streams) return;

    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Source" &&
        prev.find((x) => x.fieldName === "Trigger")?.selectedOption === "Meta"
          ? {
              ...f,
              options: streams.map((s: any) => ({
                name: s.name,
                id: s.id,
              })),
            }
          : f
      )
    );
  }, [streams]);

  useEffect(() => {
    if (!webforms) return;

    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Source" &&
        prev.find((x) => x.fieldName === "Trigger")?.selectedOption ===
          "Webform"
          ? {
              ...f,
              options: webforms?.map((w: any) => ({
                name: w?.name,
                id: w?.id,
                type: w?.type,
                branchId: w?.branchId,
              })),
            }
          : f
      )
    );
  }, [webforms]);

  const selectedSource: any = useMemo(() => {
    return fields.find((f) => f.fieldName === "Source")?.selectedOption || null;
  }, [fields]);

  useEffect(() => {
    if (!selectedSource) return;

    const triggerField = fields.find((f) => f.fieldName === "Trigger");
    const triggerValue = triggerField?.selectedOption;

    if (triggerValue !== "Webform") return;

    // Webform type
    const webformType = selectedSource?.type;

    // FILTER LOGIC
    let filteredBranchList = branchList;

    let id = webforms?.find((d: any) => d?.id === selectedSource?.sourceId);

    if (webformType === "UNIVERSAL") {
      filteredBranchList = branchList;
    } else {
      filteredBranchList = branchList.filter((b: any) => b.id === id?.branchId);
    }

    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Branch"
          ? {
              ...f,
              options: filteredBranchList.map((b: any) => ({
                name: b.branchName,
                id: b.id,
              })),
              selectedOption: "", // reset selection since filtering changed
            }
          : f
      )
    );
  }, [selectedSource, branchList]);

  const combinedAssigneesForDropdown = useMemo(() => {
    return getCombinedAssignees(employees, selectedBranchId);
  }, [employees, selectedBranchId]);

  useEffect(() => {
    setFields((prev) =>
      prev.map((f) =>
        f.fieldName === "Assignee"
          ? {
              ...f,
              options: combinedAssigneesForDropdown.map((d: any) => ({
                name: `${d.firstName} ${d.lastName}`,
                id: d.id,
              })),
            }
          : f
      )
    );
  }, [combinedAssigneesForDropdown]);

  const resetFieldInBoth = (fieldNames: string[]) => {
    // Reset in dropdown fields (right side)
    setFields((prev) =>
      prev.map((f) =>
        fieldNames.includes(f.fieldName) ? { ...f, selectedOption: "" } : f
      )
    );

    // Reset in selected fields (left side)
    setAdditionalFields((prev) =>
      prev.map((f) =>
        fieldNames.includes(f.fieldName) ? { ...f, selectedOption: "" } : f
      )
    );
  };

  const handleFieldChange = (updatedField: any, index: number) => {
    const prevField = fields[index];
    const updatedFields = [...fields];
    updatedFields[index] = updatedField;
    setFields(updatedFields);

    if (
      prevField.fieldName === "Trigger" &&
      prevField.selectedOption !== updatedField.selectedOption
    ) {
      resetFieldInBoth(["Source"]);
      resetFieldInBoth(["Course"]);
      resetFieldInBoth(["Branch"]);
      resetFieldInBoth(["Batch"]);
      resetFieldInBoth(["Assignee Method"]);
      resetFieldInBoth(["Assignee"]);
    }

    // 🔥 2) If COURSE changes → clear BATCH
    if (
      prevField.fieldName === "Course" &&
      prevField.selectedOption !== updatedField.selectedOption
    ) {
      resetFieldInBoth(["Batch"]);
    }

    // 🔥 3) If BRANCH changes → clear BATCH + ASSIGNEE
    if (
      prevField.fieldName === "Branch" &&
      prevField.selectedOption !== updatedField.selectedOption
    ) {
      resetFieldInBoth(["Batch", "Assignee"]);
    }
  };

  const isFieldEnabled = (index: number): boolean => {
    const f = fields;

    switch (f[index].fieldName) {
      case "Trigger":
        return true;

      case "Source":
        return f[0].selectedOption !== "";

      case "Branch":
      case "Course":
        return f[1].selectedOption !== "";

      case "Batch":
        return f[3].selectedOption !== "";

      case "Assignee":
        return f[5].selectedOption !== "";

      case "Assignee Method":
        return f[2].selectedOption !== "";

      default:
        return false;
    }
  };

  const SOURCE_OPTIONS: any = {
    META: streams,
    WEBFORM: webforms,
    EXCEL: [{ name: "Excel", id: "EXCEL" }],
  };

  useEffect(() => {
    const triggerField: any = fields.find(
      (f: any) => f.fieldName === "Trigger"
    );
    const selectedTrigger: any = triggerField?.selectedOption;

    if (!selectedTrigger) return;

    const updatedSourceOptions =
      SOURCE_OPTIONS[selectedTrigger?.toUpperCase()] || [];
    setFields((prev) =>
      prev.map((f) => {
        if (f.fieldName === "Source" && selectedTrigger !== "Webform") {
          return {
            ...f,
            selectedOption: "",
            options: updatedSourceOptions.map((o: any) => ({
              name: o.name,
              id: o.id,
            })),
          };
        } else if (f.fieldName === "Source" && selectedTrigger === "Webform") {
          return {
            ...f,
            selectedOption: "",
            options: updatedSourceOptions.map((o: any) => ({
              name: o.name,
              id: o.id,
              type: o?.type,
              branchId: o?.branchId,
            })),
          };
        }
        return f;
      })
    );
  }, [fields.find((f) => f.fieldName === "Trigger")?.selectedOption]);

  const handlePopupYesButton = () => {
    handleSubmit();
  };

  const handlePopupNoButton = () => {
    setIsOpen(false);
  };

  const assigneeMethodField = additionalFields?.find(
    (f) => f.fieldName === "Assignee Method"
  );

  const assigneeField = additionalFields?.find(
    (f) => f.fieldName === "Assignee"
  );

  const isAssigneeMethodSelected = Boolean(assigneeMethodField?.selectedOption);

  const isAssigneeSelected = Array.isArray(assigneeField?.selectedOption)
    ? assigneeField?.selectedOption.length > 0
    : Boolean(assigneeField?.selectedOption?.id);

  const fixedOrder = [
    "Trigger",
    "Source",
    "Course",
    "Branch",
    "Batch",
    "assigneeMethod",
    "assignee",
  ];

  const sortedAdditionalFields = [...additionalFields].sort((a, b) => {
    const i1 = fixedOrder.indexOf(a.fieldName);
    const i2 = fixedOrder.indexOf(b.fieldName);

    // if field not found in fixedOrder, send it to bottom
    const pos1 = i1 === -1 ? 999 : i1;
    const pos2 = i2 === -1 ? 999 : i2;

    return pos1 - pos2;
  });

  const requiredFields = [
    "Trigger",
    "Source",
    "Course",
    "Branch",
    "Assignee Method",
    "Assignee",
  ];

  // const hasAllRequiredFields = requiredFields.every((name) =>
  //   additionalFields?.some((f) => f.fieldName === name)
  // );
  const hasAllRequiredFields = requiredFields.every((name) =>
    additionalFields.some(
      (f) =>
        f.fieldName === name &&
        f.selectedOption !== "" &&
        f.selectedOption !== null &&
        f.selectedOption !== undefined &&
        // also check arrays (for multi-select assignee)
        (!Array.isArray(f.selectedOption) || f.selectedOption.length > 0)
    )
  );
  useEffect(() => {
    setAdditionalFields((prev) =>
      prev.map((af) => {
        const matchedField = fields.find((f) => f.fieldName === af.fieldName);
        if (!matchedField) return af; // keep it if removed or batch logic

        return {
          ...af,
          selectedOption: matchedField.selectedOption, // SYNC VALUE
        };
      })
    );
  }, [fields]);

  const mandatoryFields = [
    "Trigger",
    "Source",
    "Course",
    "Branch",
    "Assignee Method",
    "Assignee",
  ];

  const getNextMandatoryField = (startIndex: number) => {
    for (let i = startIndex + 1; i < sortedAdditionalFields.length; i++) {
      if (mandatoryFields.includes(sortedAdditionalFields[i].fieldName)) {
        return sortedAdditionalFields[i];
      }
    }
    return null;
  };

  const mandatoryOrder = [
    "Trigger",
    "Source",
    "Course",
    "Branch",
    // "Batch",
    "Assignee Method",
    "Assignee",
  ];

  const firstMissingIndex = useMemo(() => {
    for (let i = 0; i < mandatoryOrder.length; i++) {
      const name = mandatoryOrder[i];
      const exists = additionalFields.some((f) => f.fieldName === name);
      if (!exists) return i; // index of first missing
    }
    return -1;
  }, [additionalFields]);

  const isBelowMissing = (fieldName: string) => {
    if (firstMissingIndex === -1) return false; // nothing missing

    const idx = mandatoryOrder.indexOf(fieldName);

    if (idx === -1) return false; // Not a mandatory field (e.g., Batch)

    return idx > firstMissingIndex;
  };

  return (
    <div className={styles.editLeadFormWrap}>
      {loader || !course || !batchList ? (
        <AutomationSkeleton />
      ) : (
        <>
          <div
            className={styles.editLeadFormRight}
            style={{ width: "calc(100% - 445px)", overflow: "hidden" }}
          >
            <div
              style={{
                width: "100%",
                overflowY: "auto",
                maxHeight: "calc(100vh - 100px)",
                minHeight: "calc(100vh - 100px)",
                padding: "30px 26px",
              }}
            >
              <button
                className={styles.PageBackBtn}
                onClick={() => {
                  navigate(`/app/Settings/LeadAutomation`);
                }}
              >
                <ArrowBackIcon
                  sx={{
                    marginRight: "8px",
                    fontSize: "15PX",
                    color: "#667085",
                  }}
                />
                Back
              </button>
              <div
                className={styles.secondoryTitle}
                style={{ marginTop: "30px" }}
              >
                Auto Assign Configuration
              </div>
              <div
                style={{
                  marginTop: "30px",
                  backgroundColor: "rgba(249, 249, 249, 1)",
                  border: "1px solid rgba(249, 249, 249, 1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className={styles.thirdTitle}
                  style={{
                    padding: "10px",
                    fontSize: "12px",
                  }}
                >
                  ⓘ Configure how contacts will be automatically converted to
                  leads
                </div>
                {/* <div
                  style={{
                    padding: "5px 8px",
                    fontSize: "12px",
                    border: "1px soild rgba(17, 200, 155, 1)",
                    backgroundColor:
                      additionalFields?.length === 0 ||
                      !hasAllRequiredFields || // ❗ new mandatory check
                      (isAssigneeMethodSelected && !isAssigneeSelected)
                        ? "rgba(0, 0, 0, 0.26)"
                        : "rgba(17, 200, 155, 1)",
                    borderRadius: "8px",
                    marginRight: "10px",
                    color: "white",
                    pointerEvents:
                      additionalFields?.length === 0 ||
                      !hasAllRequiredFields || // ❗ new mandatory check
                      (isAssigneeMethodSelected && !isAssigneeSelected)
                        ? "none"
                        : "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsOpen(true)}
                >
                  Publish
                </div> */}
              </div>
              <div
                draggable
                onDrop={handleOnDrop}
                onDragOver={handleOnDragOver}
                className={styles.additionalBox}
                style={{
                  background:
                    additionalFields?.length > 0 ? "#fff" : "#F1F4F880",
                  border: "1px dashed #E6E6E6",
                  minHeight: "500px",
                  width: "100%",
                  padding: "20px",
                }}
              >
                {sortedAdditionalFields?.length > 0 ? (
                  <div style={{ marginTop: "20px" }}>
                    {sortedAdditionalFields?.map(
                      (field: any, index: number) => (
                        <div
                          key={index}
                          className={styles.primaryFields}
                          draggable
                          onDragStart={(e) =>
                            handleOnDragFields(e, field, index)
                          }
                          onDragOver={(e) => handleOnDragOver(e)}
                          onDropCapture={(e) =>
                            handleOnDragEnter(e, field, index)
                          }
                        >
                          <React.Fragment key={index}>
                            <SelectedFieldCard
                              label={field.fieldName}
                              value={
                                Array.isArray(field?.selectedOption)
                                  ? field?.selectedOption
                                      .map((o: any) => o.name)
                                      .join(", ")
                                  : typeof field?.selectedOption === "object" &&
                                    field?.selectedOption !== null
                                  ? field?.selectedOption?.sourceName ||
                                    field?.selectedOption?.courseName ||
                                    field?.selectedOption?.branchName ||
                                    field?.selectedOption?.batchName ||
                                    field?.selectedOption?.name ||
                                    ""
                                  : field?.selectedOption
                              }
                              onDelete={handleDeleteField}
                              deleteAction={true}
                              field={field}
                              isBelowMissingHigh={isBelowMissing(
                                field.fieldName
                              )}
                            />
                            {/* {index !== fields.length - 1 && <Connector />} */}
                            {/* {mandatoryFields.includes(field.fieldName) &&
                              getNextMandatoryField(index) && <Connector />} */}
                            {index < sortedAdditionalFields.length - 1 && (
                              <Connector
                                isBelowMissingHigh={isBelowMissing(
                                  field.fieldName
                                )}
                              />
                            )}
                          </React.Fragment>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div className={styles.additionalBoxDrag}>
                    Drag and drop fields to configure.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.editLeadFormLeft} style={{ width: "445px" }}>
            <div className={styles.secondoryTitle}>Next Step</div>
            <div>
              {fields?.map((field: any, index: number) => (
                <div
                  key={index}
                  className={styles.primaryFields}
                  draggable
                  onDragStart={(e) =>
                    isFieldEnabled(index) && field?.selectedOption !== ""
                      ? handleOnDrag(e, field)
                      : ""
                  }
                >
                  {field.fieldType === "select" && (
                    <FinalCustomizedDropdown
                      field={field}
                      onDelete={handleDeleteField}
                      isDropdownFieldFocused={isDropdownFieldFocused}
                      setIsDropdownFieldFocused={setIsDropdownFieldFocused}
                      edit={isFieldEnabled(index)}
                      onFieldChange={(updated: any) =>
                        handleFieldChange(updated, index)
                      }
                      fields={fields}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className={styles.parameterFieldBottom}>
              <div className={styles.parameterFieldBtnsWrap}>
                {cancelModal && (
                  <CancelPopup
                    open={cancelModal}
                    onClose={closeCancelModal}
                    noBtnClick={closeCancelModal}
                    yesBtnClick={cancelYesBtn}
                  />
                )}

                <SaveBtn
                  onClick={() => setIsOpen(true)}
                  disabled={
                    additionalFields?.length === 0 ||
                    !hasAllRequiredFields || // ❗ new mandatory check
                    (isAssigneeMethodSelected && !isAssigneeSelected)
                  }
                  minWidth={"100%"}
                  buttonText={"Complete Setup"}
                />
              </div>
            </div>
          </div>
        </>
      )}
      <FinalConfirmPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handlePopupYesButton={handlePopupYesButton}
        handlePopupNoButton={handlePopupNoButton}
        fields={fields}
        saveLeadAutomationConfigLoading={saveLeadAutomationConfigLoading}
        editLeadAutomationConfigLoading={editLeadAutomationConfigLoading}
      />
    </div>
  );
}

export default CreateLeadAutomationForm;
